

	import { Component } from 'vue-property-decorator';
	import { PersonDetailsView } from '@client/views/industry/PersonDetailsView';
	import { Company, Pro, SubjectAggregate, Account } from '@shared/models';
	import ProGeneralInfo from './ProGeneralInfo.vue';
	import CompanyItemList from '../companies/CompanyItemList.vue';
	import AccountList from '../../common/AccountList.vue';

	@Component({
		components: {
			CompanyItemList,
			AccountList,
			ProGeneralInfo,
		},
	})
	export default class ProDetails extends PersonDetailsView<Pro> {

		public model: Pro = new Pro();
		public imageUrl: string = '';
		public topCompanies: Array<SubjectAggregate<Company>> = [];
		public accounts: Account[] = [];

		public async mounted() {
			if (this.$route.name === 'pro-details' ) { this.$router.push({ name: 'pro-decks', params: { id: this.$route.params.id }}); }
			this.loading = true;
			try {
				const modelId = this.$route.params.id;
				this.model = await this.$api.proService.get(modelId);
				this.setTitle(`Skate Lurker - ${this.model.displayName} Pro Skateboarder`);
				this.imageUrl = `https://lurker.blob.core.windows.net/pros/d_pro_${this.model.id}.jpg`;
				this.topCompanies = (await this.$api.companyService.listByProWithCount(modelId, 0, 4)).results;
				this.accounts = await this.$api.proAccountService.list(modelId);
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading this professional skateboarder');
			} finally {
				this.loading = false;
			}
		}

		public handleBrokenImage($event: any) {
			$event.target.src = `${this.settings.baseUrl}/Assets/Stubs/default-pro.jpg`;
		}

	}

